export default function ProfileHeader() {
  return (
    <section className="pt-8 pb-6 text-white lg:pt-6 lg:pb-5">
      <div>
        <h1 className="m-0 font-bold tracking-[-0.02em] leading-[44px] text-[32px] text-white">
          Мой профиль
        </h1>

        <p className="mt-6 mb-0 text-white/85 leading-[28px] lg:mt-3">
          Управляйте настройками своей учетной записи и просматривайте историю транзакций.
        </p>
      </div>
    </section>
  );
}